<template>
  <span v-if="crossed == 1">
    <s>{{first}}{{Asterisk()}}</s>
    {{Separator()}}
    <span>{{second}}{{Asterisk()}}</span>
  </span>
  <span v-else-if="crossed == 2">
    <span>{{first}}{{Asterisk()}}</span>
    {{Separator()}}
    <s>{{second}}{{Asterisk()}}</s>
  </span>
  <span v-else>
    <span>{{first}}{{Asterisk()}}</span>
    {{Separator()}}
    <span>{{second}}{{Asterisk()}}</span>
  </span>
</template>

<script>
export default {
  name: 'w-crossed-out',
  props: {
    crossed: Number,
    separator: String,
    asterisk: String,
    first: String,
    second: String
  },
  data() {
    return {};
  },
  methods: {
    Separator() {
      return this.separator || '/';
    },
    Asterisk() {
      return this.asterisk || '*';
    }
  }
};
</script>

<style>
</style>